import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { Notification, NotificationRef, NotificationType } from '../models/notification-models';

@Injectable({
  providedIn: 'root',
})
export class NotificationService {
  notify$ = new Subject<Notification>();

  constructor() {}

  public notify(type: NotificationType, text: string, button: string, duration: number): NotificationRef {
    const notification = new Notification();
    notification.type = type;
    notification.text = text;
    notification.button = button;
    notification.duration = duration;
    this.notify$.next(notification);
    return new NotificationRef(notification);
  }

  public success(text: string): NotificationRef {
    return this.notify(NotificationType.success, text, 'Forstået', 4000);
  }

  public warning(text: string): NotificationRef {
    return this.notify(NotificationType.warning, text, 'Forstået', 4000);
  }

  public error(text: string): NotificationRef {
    return this.notify(NotificationType.error, text, 'Forstået', 4000);
  }
}
